import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";

interface props {
  data:any
  setOpenJsonDialog: React.Dispatch<React.SetStateAction<boolean>>
  className?: string;
  // setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  // getMemberList:any;
}

// const SampleRejectRsnDialog = () => {
const SsbJsonDialog = (props: props) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const [formattedJson, setFormattedJson] = useState("")

  const formatJson = (obj:any) => {
    if (!obj || typeof obj !== 'object') return '';

    const jsonString = JSON.stringify(obj, null, 2);

    const formattedHtml = jsonString.split('\n').map((line:any) => {
      const indent = line.match(/^\s*/)[0].replace(/ /g, '&nbsp;');
      const lineWithColor = line.replace(/"([^"]+)":/g, '<span style="color: #ffd415;">"$1"</span>: ');
      return `${indent}${lineWithColor}`;
    }).join('<br />');

    return formattedHtml;
  };

  const getJson = async (data:any) => {
    let parsed = data;
    if (typeof data === 'string') {
      try { parsed = JSON.parse(data); } catch { parsed = null; }
    }
    setFormattedJson(formatJson(parsed));
  }

  useEffect(() => {

    // console.log('props.data',props.data)
    getJson(props.data);

    const handleSelectAll = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'a') {
        e.preventDefault();
        const dialog = document.querySelector('.json-dialog-content');
        if (dialog) {
          const range = document.createRange();
          range.selectNodeContents(dialog);
          const sel = window.getSelection();
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      }
    };
    document.addEventListener('keydown', handleSelectAll);
    return () => document.removeEventListener('keydown', handleSelectAll);

  }, [props.data]);

  // useEffect(() => {
  //   const handleSelectAll = (e: KeyboardEvent) => {
  //     if (e.ctrlKey && e.key === 'a') {
  //       e.preventDefault();
  //       const dialog = document.querySelector('.json-dialog-content');
  //       if (dialog) {
  //         const range = document.createRange();
  //         range.selectNodeContents(dialog);
  //         const sel = window.getSelection();
  //         sel?.removeAllRanges();
  //         sel?.addRange(range);
  //       }
  //     }
  //   };
  //   document.addEventListener('keydown', handleSelectAll);
  //   return () => document.removeEventListener('keydown', handleSelectAll);
  // }, []);

  return (
    <Box >
    <Dialog maxWidth="lg" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>JSON 미리보기</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers className={props.className}>
        <Box sx={{ width: "1400px", margin: '12px auto' }}>
            <pre style={{
                backgroundColor: '#282c34',
                color: '#8ae9fa',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                fontFamily: 'Courier New, Courier, monospace',
                fontSize: '12px',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                overflowX: 'auto',
            }}>
                <div dangerouslySetInnerHTML={{ __html: formattedJson }} />
            </pre>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setOpenJsonDialog(false);
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default SsbJsonDialog;
